import React from 'react';
import { IPrice } from '../../models/generated/cms.interface';
import { Translate } from '../translate';

export interface IPriceProps {
    obj?: IPrice;
    perUnit?: boolean;
    noCurrency?: boolean;
    className?: string;
}

export const Price: React.FC<IPriceProps> = React.memo(({ obj, perUnit = false, className = "", noCurrency = false }: IPriceProps) => obj ? (
    <span className={className}>
        {!noCurrency && `${obj.currency} `}{obj.formatted}{perUnit ? <Translate value={(t): string => ` ${t.general.perUnit}`} defaultValue="/ unit" /> : null}
    </span>
) : null);
